import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect', '/bind', '/register', '/400']
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (!store.state.nutral.alreadyGet) {
    //传入二级域名
    if (
      location.hostname.split('.')[0] !== 'eecm' &&
      location.hostname != 'localhost' &&
      !/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(location.hostname)
    ) {
      const config = await store.dispatch('GetConfig', location.hostname.split('.')[0])
      // const config = await store.dispatch('GetConfig', '978')
      if (config == null) {
        next('/400')
        return
      } else {
        next(`/login?redirect=${to.fullPath}`)
        return
      }
    }
  }
  if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        try {
          const info = await store.dispatch('GetInfo')
          isRelogin.show = false
          const accessRoutes = await store.dispatch('GenerateRoutes')
          // 根据roles权限生成可访问的路由表
          router.addRoutes(accessRoutes) // 动态添加可访问路由表
          next({ ...to, replace: true }) // 确保addRoutes已完成
          if (to.path != '/error') {
            store.commit('SET_LAST_ROUTER', to.path)
            if (to.path.split('/').length == 3) {
              store.commit('SET_LAST_MENU_ROUTER', to.path)
            }
          } //保存当前路由
        } catch (err) {
          if (err.code == 401) {
            store.dispatch('LogOut').then(() => {
              location.href = '/index'
            })
          }
          if (to.fullPath == '/error') {
            next()
            NProgress.done()
          } else {
            next('/error')
            NProgress.done()
          }
        }
      } else {
        if (to.path != '/error') {
          store.commit('SET_LAST_ROUTER', to.path)
          if (to.path.split('/').length == 3) {
            store.commit('SET_LAST_MENU_ROUTER', to.path)
          }
        }
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
